import { useCallback, useMemo } from 'react';
import { useCoachUsage } from '../context/CoachUsageContext';

export const useCoachQuota = () => {
  const {
    coachLimitReached,
    usageSeconds,
    limitMinutes,
    isLoading,
    error,
    refreshCoachUsage,
    setCoachUsage,
  } = useCoachUsage();

  const remainingSeconds = useMemo(() => {
    if (limitMinutes === -1) {
      return Infinity;
    }
    return Math.max(0, (limitMinutes * 60) - usageSeconds);
  }, [limitMinutes, usageSeconds]);

  const markLimitReached = useCallback(() => {
    if (limitMinutes !== -1) {
      setCoachUsage({ usageSeconds: limitMinutes * 60, limitMinutes });
    }
  }, [limitMinutes, setCoachUsage]);

  return {
    coachLimitReached,
    usageSeconds,
    limitMinutes,
    remainingSeconds,
    isLoading,
    error,
    refreshCoachUsage,
    setCoachUsage,
    markLimitReached,
  };
};
